export default {
  map_unavailable: 'Não foi possível carregar o mapa. Recarregue a página para tentar novamente.',
  stubs: {
    name: 'Zona de entrega {{number}}',
  },
  buttons: {
    add_new_zone: 'Adicionar nova zona',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar zonas de entrega',
  },
};
